import React, { useState } from "react";
import { Button } from "@mui/material";
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";

import {
  addDoc,
  collection,
  // doc,
  serverTimestamp,
  // updateDoc,
} from "firebase/firestore";
import { db } from "../../firebase";
import { useAuth } from "../../contexts/AuthContext";
import { showCustomToast } from "../Misc/CustomToast";
import InputComponentNoTitle from "../InputComponentNoTitle";
import DropDownComponentSortedNoTitle from "../DropDownComponentSortedNoTitle";
import DropDownComponentNoTitle from "../DropDownComponentNoTitle";
import DatePickerComponentNoTitle from "../DatePickerComponentNoTitle";
import PhoneNumberInputNoTitle from "../PhoneNumberInputNoTitle";
import TopTitleFormComponentMobile from "./TopTitleFormComponentMobile";
import rehabs from "../../api/rehabs";

const PH_REHAB_ID = "miracles_asia_philippines";

function AddClientMobile(props) {
  // const imageConfig = {
  //   quality: 0.9,
  //   maxWidth: 200,
  //   autoRotate: true,
  //   debug: true,
  // };

  const { currentUser } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [nickname, setNickname] = useState("");
  const [clientStatus, setClientStatus] = useState("");
  const [rehabId, setRehabId] = useState("miracles_asia_thailand");
  // const [gender, setGender] = useState("");
  const [gender] = useState("");

  const [personalEmail, setPersonalEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState();
  const [country, setCountry] = useState("");
  const [primaryAddiction, setPrimaryAddiction] = useState("");
  // const [province, setProvince] = useState("");
  const [clientSource, setClientSource] = useState("");
  // const [open, setOpen] = React.useState(false);
  const [durationOfStay, setDurationOfStay] = useState("");
  const [eta, setEta] = useState("");

  const handlEtaChange = (event) => {
    setEta(event);
  };

  const handleClientSource = (event) => {
    setClientSource(event);
  };

  const handlePrimaryAddictionChange = (event) => {
    setPrimaryAddiction(event);
  };

  const handleDurationOfStayChange = (value) => {
    setDurationOfStay(value);
  };

  const handleFirstNameChange = (event) => {
    setFirstName(event);
  };

  const handleLastNameChange = (event) => {
    setLastName(event);
  };

  const handleNicknameChange = (event) => {
    setNickname(event);
  };

  const handlePersonalEmailChange = (event) => {
    setPersonalEmail(event);
  };

  const handlePhoneNumberChange = (value) => {
    setPhoneNumber(value);
  };

  const handleCountryChange = (value) => {
    setCountry(value);
  };

  const handleClientStatus = (value) => {
    setClientStatus(value);
  };

  const handleRehabChange = (event) => {
    const nextRehabId = event.target.value;
    setRehabId(nextRehabId);
    if (nextRehabId === PH_REHAB_ID) {
      setDurationOfStay("");
    }
  };

  const selectedRehab = rehabs.find((rehab) => rehab.id === rehabId);
  const requiresDurationOfStay = rehabId !== PH_REHAB_ID;

  // const handleClientPictureChange = (file) => {
  //   setClientPicture(file);
  // };

  const handleSave = async () => {
    if (
      clientStatus &&
      rehabId &&
      selectedRehab &&
      firstName &&
      lastName &&
      personalEmail &&
      phoneNumber &&
      country &&
      primaryAddiction &&
      (!requiresDurationOfStay || durationOfStay) &&
      clientSource
    ) {
      setIsLoading(true);
      try {
        const newClientRef = await addDoc(collection(db, "clients"), {
          creatorName: currentUser.displayName,
          dateOfCreation: serverTimestamp(),
          firstName,
          lastName,
          gender,
          personalEmail,
          phoneNumber,
          country,
          clientStatus: clientStatus,
          rehabId,
          rehabName: selectedRehab.name,
          rehabCountry: selectedRehab.country,
          rehabLocation: selectedRehab.location,
          rehabTimezone: selectedRehab.timezone,
          rehabCurrency: selectedRehab.currency,
          primaryAddiction,
          durationOfStay,
          eta,
          nickname,
          clientSource,
          staffId: currentUser.uid,
          staffEmail: currentUser.email,
          staffName: currentUser.displayName,
        });

        console.log(`Client added with ID: ${newClientRef.id}`);
        showCustomToast(`Client successfully added!`, "success");

        setIsLoading(false);
        props.closemodal();
      } catch (error) {
        console.error("Error adding client: ", error);
        setIsLoading(false);
      }
    } else {
      showCustomToast(
        `Some mandatory fields are empty. Please check.`,
        "error"
      );
    }
  };

  return (
    <div style={{ width: "auto", height: "100%" }}>
      <TopTitleFormComponentMobile
        title="ADD CLIENT"
        closemodal={props.closemodal}
      />

      <div style={{ marginTop: "0px", height: "75%", overflowY: "scroll" }}>
        <div className="tab-form-container-v2">
          <div className="addclient-items-wrap">
            <div className="addclient-item-wrap-left-mobile">
              Status
              <span style={{ color: "red", paddingLeft: "5px" }}>*</span>
            </div>

            <div className="addclient-item-wrap-right-mobile">
              <DropDownComponentNoTitle
                api="clientStatus"
                width="300"
                isRequired={true}
                value={clientStatus}
                onChange={handleClientStatus}
                displayInHouseAsActive={rehabId === PH_REHAB_ID}
              />
            </div>
          </div>

          <div className="addclient-items-wrap">
            <div className="addclient-item-wrap-left-mobile">
              Rehab / Facility
              <span style={{ color: "red", paddingLeft: "5px" }}>*</span>
            </div>

            <div className="addclient-item-wrap-right-mobile">
              <select
                className="add-client-rehab-select"
                value={rehabId}
                onChange={handleRehabChange}
              >
                {rehabs.map((rehab) => (
                  <option key={rehab.id} value={rehab.id}>
                    {rehab.name}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="addclient-items-wrap">
            <div className="addclient-item-wrap-left-mobile">
              First name
              <span style={{ color: "red", paddingLeft: "5px" }}>*</span>
            </div>

            <div className="addclient-item-wrap-right-mobile">
              <InputComponentNoTitle
                width="300"
                isRequired={true}
                value={firstName}
                onChange={handleFirstNameChange}
              />
            </div>
          </div>

          <div className="addclient-items-wrap">
            <div className="addclient-item-wrap-left-mobile">
              Last name
              <span style={{ color: "red", paddingLeft: "5px" }}>*</span>
            </div>

            <div className="addclient-item-wrap-right-mobile">
              <InputComponentNoTitle
                width="300"
                isRequired={true}
                value={lastName}
                onChange={handleLastNameChange}
              />
            </div>
          </div>

          <div className="addclient-items-wrap">
            <div className="addclient-item-wrap-left-mobile">
              Preferred name
              {/* <span style={{ color: "red", paddingLeft: "5px" }}>*</span> */}
            </div>

            <div className="addclient-item-wrap-right-mobile">
              <InputComponentNoTitle
                width="300"
                isRequired={true}
                value={nickname}
                onChange={handleNicknameChange}
              />
            </div>
          </div>

          <div className="addclient-items-wrap">
            <div className="addclient-item-wrap-left-mobile">
              Prefered Email
              <span style={{ color: "red", paddingLeft: "5px" }}>*</span>
            </div>

            <div className="addclient-item-wrap-right-mobile">
              <InputComponentNoTitle
                width="300"
                isRequired={true}
                value={personalEmail}
                onChange={handlePersonalEmailChange}
              />
            </div>
          </div>

          <div className="addclient-items-wrap">
            <div className="addclient-item-wrap-left-mobile">
              Phone Number
              <span style={{ color: "red", paddingLeft: "5px" }}>*</span>
            </div>

            <div className="addclient-item-wrap-right-mobile">
              <PhoneNumberInputNoTitle
                width="300"
                isRequired={true}
                value={phoneNumber}
                onChange={handlePhoneNumberChange}
              />
            </div>
          </div>

          <div className="addclient-items-wrap">
            <div className="addclient-item-wrap-left-mobile">
              Country
              <span style={{ color: "red", paddingLeft: "5px" }}>*</span>
            </div>

            <div className="addclient-item-wrap-right-mobile">
              <DropDownComponentSortedNoTitle
                api="countries"
                title="Country"
                value={country}
                onChange={handleCountryChange}
              />
            </div>
          </div>
          <div className="addclient-items-wrap">
            <div className="addclient-item-wrap-left-mobile">
              Primary Addiction
              <span style={{ color: "red", paddingLeft: "5px" }}>*</span>
            </div>

            <div className="addclient-item-wrap-right-mobile">
              <DropDownComponentNoTitle
                api="addictions"
                title="Primary Addiction (either substance or process above)"
                value={primaryAddiction}
                onChange={handlePrimaryAddictionChange}
              />
            </div>
          </div>

          {requiresDurationOfStay && (
            <div className="addclient-items-wrap">
              <div className="addclient-item-wrap-left-mobile">
                Intended Length of Stay
                <span style={{ color: "red", paddingLeft: "5px" }}>*</span>
              </div>

              <div className="addclient-item-wrap-right-mobile">
                <DropDownComponentSortedNoTitle
                  api="durationOfStay"
                  title="Intended duration of stay"
                  width="250px"
                  value={durationOfStay}
                  onChange={handleDurationOfStayChange}
                />
              </div>
            </div>
          )}

          <div className="addclient-items-wrap">
            <div className="addclient-item-wrap-left-mobile">
              Estimate Arrival Date
              {/* <span style={{ color: "red", paddingLeft: "5px" }}>*</span> */}
            </div>

            <div className="addclient-item-wrap-right-mobile">
              <DatePickerComponentNoTitle
                width="250px"
                title="Estimate Date of Arrival"
                value={eta}
                onChange={handlEtaChange}
              />
            </div>
          </div>

          <div className="addclient-items-wrap">
            <div className="addclient-item-wrap-left-mobile">
              Source
              <span style={{ color: "red", paddingLeft: "5px" }}>*</span>
            </div>

            <div className="addclient-item-wrap-right-mobile">
              <DropDownComponentSortedNoTitle
                api="clientSource"
                title="Source"
                value={clientSource}
                onChange={handleClientSource}
              />
            </div>
          </div>
        </div>
      </div>
      <div
        className="line4-modal-newdesign-mobile"
        style={{
          height: "15%",
          borderBottomLeftRadius: "10px",
          borderBottomRightRadius: "10px",
        }}
      >
        <>
          <Button
            variant="contained"
            style={{ backgroundColor: "white", color: "black" }}
            // disabled={!(pic1Url && pic2Url && pic3Url && pic4Url && pic5Url)}
            onClick={props.closemodal}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleSave}
            style={
              isLoading
                ? {
                    backgroundColor: "red",
                    color: "white",
                    marginLeft: "15px",
                    marginRight: "5px",
                  }
                : {
                    backgroundColor: "#1565C0",
                    color: "white",
                    marginLeft: "15px",
                    marginRight: "5px",
                  }
            }
            disabled={isLoading}
            //   onClick={handlePostRecord}
          >
            {isLoading ? "ADDING CLIENT..." : "ADD CLIENT"}
          </Button>
        </>
      </div>
    </div>
  );
}

export default AddClientMobile;
